import { createApp } from 'vue'
import { createPinia } from 'pinia'
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'
import App from './App.vue'
import router from './router'
import './styles/main.css'

dayjs.locale('pt-br')

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.mount('#app')
